import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomResourcesValue } from '../resources';

export const GROUP_CHAT_URL_SEARCH_PARAM_KEY = 'channelUrl';

export const useGoToChannel = () => {
  const navigate = useNavigate();

  return useCallback(
    (channelUrl: string) =>
      navigate(
        `/${CustomResourcesValue.CHAT}?${new URLSearchParams({
          [GROUP_CHAT_URL_SEARCH_PARAM_KEY]: channelUrl,
        })}`
      ),
    [navigate]
  );
};
